import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav data-testid="main-nav" className="bg-poster-accent text-white px-6 py-4 sticky top-0 z-50 shadow-md">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <Link to="/" data-testid="nav-brand-link" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <div className="w-8 h-8 bg-white text-poster-accent flex items-center justify-center font-poster text-xl">P</div>
          <div>
            <span className="font-poster text-2xl tracking-wider uppercase text-white">PRINTPULSE DIRECT</span>
            <span className="block text-[9px] font-mono-lbl tracking-widest uppercase text-sky-100">
              Independent Diagnostic Desk
            </span>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-xs font-mono-lbl uppercase tracking-widest transition-colors ${
                  isActive ? "text-white font-bold" : "text-sky-100 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-fast-support-button"
            className="px-4 py-2 bg-poster-ink hover:bg-black text-white font-mono-lbl text-xs uppercase tracking-wider font-bold transition-colors"
          >
            Fast Support
          </Link>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden mt-4 border-t border-white/20 pt-4 flex flex-col gap-4">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `text-xs font-mono-lbl uppercase tracking-widest ${
                  isActive ? "text-white font-bold" : "text-sky-100"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-mobile-fast-support-button"
            onClick={() => setOpen(false)}
            className="px-4 py-2 bg-poster-ink text-white font-mono-lbl text-xs uppercase tracking-wider font-bold text-center"
          >
            Fast Support
          </Link>
        </div>
      )}
    </nav>
  );
}
